const prefix = "[AUTH]";

export default {
    AUTHORIZE_REQUEST: `${prefix} AUTHORIZE_REQUEST`,
    AUTHORIZE_SUCCESS: `${prefix} AUTHORIZE_SUCCESS`,
    AUTHORIZE_FAILED: `${prefix} AUTHORIZE_FAILED`,
    WRITE_ACCESS_TOKEN: `${prefix} WRITE_ACCESS_TOKEN`,
    CLEAR_ACCESS_TOKEN: `${prefix} CLEAR_ACCESS_TOKEN`,
};
